const version = require('../package.json').version;

const appVersion = {
  install: (Vue) => {
    Vue.prototype.$appVersion = version || 0;
  }
}

export default appVersion
  